import Swal from 'sweetalert2';
import { Color } from '../../assets/color';
import * as actionTypes from "../action-types";
import { getAPI, postAPI } from '../../utils/api-function';
import { access_token, refresh_token } from '../../utils/constant';
import { put, call, takeLeading, select } from 'redux-saga/effects';
import { change_password, get_superadmin_admin_partner_details, partner_forget_password, partner_login, reset_password, superadmin_admin_forget_password, superadmin_admin_login } from '../../utils/api-routes';

//! Superadmin-Admin
function* superadminAdminLogin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield postAPI(superadmin_admin_login, payload?.data);
        console.log("Superadmin-Admin Login Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
            localStorage.setItem(access_token, data?.result?.access_token);
            localStorage.setItem(refresh_token, data?.result?.refresh_token);
            localStorage.setItem('role', data?.result?.role);
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed To Login', showConfirmButton: false, timer: 2000, });
        console.log("Superadmin-Admin Login Saga Error ::: ", error)
    }
};

//! Partner
function* partnerLogin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield postAPI(partner_login, payload?.data);
        console.log("Partner Login Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
            localStorage.setItem(access_token, data?.result?.access_token);
            localStorage.setItem(refresh_token, data?.result?.refresh_token);
            localStorage.setItem('role', data?.result?.role);
            localStorage.setItem('label', data?.result?.label || 'Partner');
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed To Login', showConfirmButton: false, timer: 2000, });
        console.log("Partner Login Saga Error ::: ", error)
    }
};

//! Password
function* changePassword(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield postAPI(change_password, payload?.data);
        console.log("Change Password Saga Response ::: ", data);

        if (data) {
            Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed To Login', showConfirmButton: false, timer: 2000, });
        console.log("Change Password Saga Error ::: ", error)
    }
};

function* logout(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)
        const userDetails = yield select(state => state?.authReducer?.superadminAdminPartnerDetails)

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to logout?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            Swal.fire({ icon: "success", text: 'Logout successfully.', showConfirmButton: false, timer: 2000 });
            localStorage.clear();
            yield call(payload?.onComplete, userDetails?.role == 'Partner' ? '/auth/login/partner' : '/auth/login');
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message || 'Failed To Login', showConfirmButton: false, timer: 2000, });
        console.log("Change Password Saga Error ::: ", error)
    }
};

function* superadminAdminForgetPassword(action) {
    try {
        const { payload } = action;
        console.log("Superadmin Admin Forget Password Saga Payload ::: ", payload);

        const { data } = yield postAPI(superadmin_admin_forget_password, payload?.data);
        console.log("Superadmin Admin Forget Password Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: data?.message || 'We have sent you a email for password reset.', showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed to sent forget password email.', showConfirmButton: false, timer: 2000, });
        console.log("Superadmin Admin Forget Password Saga Error ::: ", error?.response?.data);
    }
};

function* partnerForgetPassword(action) {
    try {
        const { payload } = action;
        console.log("Partner Forget Password Saga Payload ::: ", payload);

        const { data } = yield postAPI(partner_forget_password, payload?.data);
        console.log("Partner Forget Password Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: data?.message || 'We have sent you a email for password reset.', showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed to sent forget password email.', showConfirmButton: false, timer: 2000, });
        console.log("Partner Forget Password Saga Error ::: ", error?.response?.data);
    }
};

function* resetPassword(action) {
    try {
        const { payload } = action;
        console.log("Reset Password Saga Payload ::: ", payload);

        const { data } = yield postAPI(reset_password, payload?.data);
        console.log("Reset Password Saga Response ::: ", data);

        if (data?.status) {
            Swal.fire({ icon: "success", text: data?.message || 'Password reset successfully.', showConfirmButton: false, timer: 2000 });
            localStorage.clear();
            yield put({ type: actionTypes.SET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload: null });
            yield put({ type: actionTypes.GET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload: null });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed to reset password.', showConfirmButton: false, timer: 2000, });
        console.log("Reset Password Saga Error ::: ", error?.response?.data);
    }
};

//! Details
function* getSuperadminAdminPartnerDetails() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_superadmin_admin_partner_details);
        console.log("Get Superadmin-Admin Details Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload: data?.result });
        } else {
            Swal.fire({ icon: "info", text: 'Please login.', showConfirmButton: false, timer: 2000 });
            yield put({ type: actionTypes.SET_SUPERADMIN_ADMIN_PARTNER_DETAILS, payload: {} });
            localStorage.clear();
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        console.log("Get Superadmin-Admin Details Saga Error ::: ", error?.response?.data?.message);
        localStorage.clear();
    }
};

export default function* authSaga() {
    //* Superadmin-Admin
    yield takeLeading(actionTypes.SUPERADMIN_ADMIN_LOGIN, superadminAdminLogin);

    //* Partner
    yield takeLeading(actionTypes.PARTNER_LOGIN, partnerLogin);

    //* Password
    yield takeLeading(actionTypes.CHANGE_PASSWORD, changePassword);
    yield takeLeading(actionTypes.LOGOUT, logout);
    yield takeLeading(actionTypes.SUPERADMIN_ADMIN_FORGET_PASSWORD, superadminAdminForgetPassword);
    yield takeLeading(actionTypes.PARTNER_FORGET_PASSWORD, partnerForgetPassword);
    yield takeLeading(actionTypes.RESET_PASSWORD, resetPassword);

    //* Details
    yield takeLeading(actionTypes.GET_SUPERADMIN_ADMIN_PARTNER_DETAILS, getSuperadminAdminPartnerDetails);
};